import React, { useState, useEffect, useMemo, useCallback } from "react";
import { useLocation } from "react-router-dom";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import {
  PRICE_SCHEDULE_MODES,
  LEGACY_SCREEN_VIEW, NO_CHANGE_OF_INFO
} from "../../common_nextgen/utils/Constants";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import { useModal } from "../../common_nextgen/hooks/ModalContext";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import { formFields } from "./AccumulatorOverrideStateScheduleConfig";
import { formFieldsAdd } from "./AccumulatorOverrideStateScheduleAddConfig";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";
import { useLocationState } from "../../common_nextgen/common_components/common-hooks/useLocationState";
import useLookupNavigation from "../../common_nextgen/common_components/common-hooks/useLookupNavigation";
const { ACCUMULATOR_OVERRIDE_SCHEDULE_STATE } = ROUTE_PATHS;

const screenInfo = {
  ADD: ["Add State CSR Criteria in Accum O/R Sched", "RCAOT002"],
  CHANGE: ["State CSR Criteria Detail in Accum O/R Sched", "RCAOT003"],
  VIEW: ["State CSR Criteria Detail in Accum O/R Sched", "RCAOT003"],
};

const AccumulatorOverrideStateScheduleForm = ({ mode }) => {
  const { axios_helper_no_header } = useAxios();
  const location = useLocation();
  // const { selectedPriceSchedules = [],
  //   previousScreen = '/accumulator-overrride-schedule',
  //   currentIndex: initialIndex = 0,
  //   rowData} = location.state || {};

  //const { state: stateVal } = location;
  /* const stateVal = location.state || [];
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);*/
  const { previousState, currentState, setStateVal } = useLocationState({
    initialState: location.state ?? [],
  });
  //console.log("current state in form", currentState, previousState);
  let {
    selectedCSRStates = [],
    previousScreen = ACCUMULATOR_OVERRIDE_SCHEDULE_STATE,
    currentIndex: initialIndex = 0,
    paramsData,
    lookupScreen,
    lookupParams,
    formData: baseFormData = {},
    navigateData,
    currentMode: initialCurrentMode = mode,
    dataDrafted: initialDataDrafted = false,
    lookupMode: initialLookupMode = false,
  } = currentState;
  console.log("current state", currentState);
  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(initialCurrentMode);
  const [initialFormData, setInitialFormData] = useState(baseFormData);
  const [constraintErrors, setConstraintErrors] = useState([]);
  const [dataDrafted, setDataDrafted] = useState(initialDataDrafted);
  //const [externalMo]
  const toast = useToast();

  const { showModal } = useModal();
  /* const [lookupData, setLookupData] = useState({});
  const handleReceiveData = (data) => {
    //setInitialFormData({ ...initialFormData, ...data });
    if (data && Object.keys(data).length) {
      setLookupData(data);
    }
  };
  const fetchLookupData = (lookupScreen, params, formData) => {
    showModal(lookupScreen, { params }, handleReceiveData, formData);
  };

  const viewLookupDetails = (lookupScreen, params, formData) => {
    const { viewType, fieldMapping } = params;
    const { default: screenNumber } = lookupScreen;
    if (viewType === "legacy") {
      const { default: viewParams } = fieldMapping;
      const paramData = viewParams.reduce((acc, item) => {
        acc[item["legacy"]] = formData[item["source"]];
        return acc;
      }, {});
      const message = {
        message: "navigate-to-presto",
        programCode: LEGACY_SCREEN_VIEW[screenNumber],
        parameters: paramData,
      };
      console.log("message", message);
      window.top?.postMessage(message, "*");
    } else {
      showModal(lookupScreen, { params }, null, formData, true);
    }
  }; */

  const {
    lookupData,
    fetchLookupData,
    viewLookupDetails,
    lookupMode,
    setLookupMode,
  } = useLookupNavigation({
    initialFormData,
    initialLookupMode,
    initialIndex: currentIndex,
    lookupScreen,
    lookupParams,
    navigateData,
    previousState,
    currentState,
    currentMode,
  });

  const handleBack = () => {
    if (currentIndex < selectedCSRStates.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setLookupMode(false);
      setInitialFormData({});
      setDataDrafted(false);
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const getPageTitle = useCallback(() => {
    const [screenTitle, screenNumber] = isAddMode(currentMode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  }, [currentMode]);

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";
    let infoChanged = true;

    if (isAddMode(currentMode)) {
      url = "api/aotstatescheduleovrd";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/aotstatescheduleovrd";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];
    

    if (
      JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData) &&
      !dataDrafted
    ) {
      infoChanged = false;
    }
  }

    const data = { ...dataForSubmission, screenNumber, infoChanged };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      if (responseStatus.message === NO_CHANGE_OF_INFO) {
              toast.current.show({
                severity: "info",
                summary: "",
                detail: responseStatus.message,
                life: 3000,
              });
            } else {
              toast.current.show({
                severity: "success",
                summary: "",
                detail: responseStatus.message,
                life: 3000,
              });
      setInitialFormData(responseData);
      setDataDrafted(false);
      if (isAddMode(currentMode)) {
        setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      }
    } }catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => {
        setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
        setLookupMode(false);
      };
      keyName.chmod = "View";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex, lookupMode]);

  useEffect(() => {
    const fetchInitialData = async () => {
      console.log("paramsData ->", paramsData);
      console.log("selectedCSRStates ->", selectedCSRStates);

      let url = isAddMode(currentMode)
        ? `api/aotstatescheduleovrd/initial-form-data/${encodeURIComponent(
            paramsData.aosAccumOvrdSchedule
          )}?aocSeqNbr=${paramsData.aocSeqNbr}`
        : `api/aotstatescheduleovrd/${encodeURIComponent(
            selectedCSRStates[currentIndex].aosAccumOvrdSchedule
          )}?aocSeqNbr=${
            selectedCSRStates[currentIndex].aocSeqNbr
          }&aotStateCsrLevel=${
            selectedCSRStates[currentIndex].aotStateCsrLevel
          }&aotSeqNbr=${selectedCSRStates[currentIndex].aotSeqNbr}`;

      try {
        const { responseData } = await axios_helper_no_header("GET", url);
        setInitialFormData(responseData);
      } catch (e) {
        console.log(e);
      }
    };

    if (!Object.keys(initialFormData).length) fetchInitialData();
  }, [mode, currentIndex, initialFormData]);

  const removeStatus = () => {
    if (isAddMode(currentMode)) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={removeStatus() ? formFieldsAdd : formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
          lookupData={lookupData}
          fetchLookupData={fetchLookupData}
          viewLookupDetails={viewLookupDetails}
        />
      </div>
    </div>
  );
};

export default AccumulatorOverrideStateScheduleForm;
